import Stepper from '@ricadesign/vue-stepper'
import Vue from 'vue';

import routes from '@/js/router/wizard';
import store from '@/js/store';

Vue.use(Stepper, { store, routes: routes[0].children });
